<template>
  <div class="bg-canvas">
      <NuxtLayout>
          <template #body_page>
              <Banner :title="`Traveller Protections`"/>
              <div class='maxw-890 ma-0-auto pl-25 pr-25 mb-101'>
                  <p>Your trip is booked with Local Designers delivering professional services. Designer Journeys has carefully selected these providers for you and that’s why we take the responsibilities described in our Traveller Protections (the "Guarantees").
                  </p>
                  <p>
                      You are paying to Designer Journeys as a payment processing agent, and we transfer your funds to the Local Designers. Your legal relationship is with the Local Designer (the trip organiser).
                  </p>
                  <p>
                      <strong class='fw-700'>Local Designer Financial Default Guarantee.</strong> In the very unlikely event of a trip non-fulfilment due to the financial default of the Local Designer, the Local Designer Financial Default Guarantee provides that your prepayment will be fully refunded from Designer Journeys.
                  </p>
                  <p>
                      "Financial default" means the Local Designer substantially fails to provide the package of services described on the Designer Journeys website as being the components of the trip you purchased, due to the credit or other financial failure on the part of the Local Designer.
                  </p>
                  <p>
                      <strong class='fw-700'>
                          The Guarantee does not cover:
                      </strong>
                  </p>
                  <p>
                      - Any consequence of any "force majeure" events, like wars, terrorism, strikes, acts of God, weather, pandemics, and other events outside of our reasonable control or the reasonable control of the Local Designer.
                  </p>
                  <p>
                      - Any consequence of your failure to fulfil any obligation on your part, including making payments when required, providing completely accurate information, having the necessary travel documents or permits, being at a necessary embarkation or departure point, or any violation of our Terms of Use
                  </p>
                  <p>
                      - Any conduct on your part (or any of your agents) that causes you to miss or be disqualified for any component of the trip package
                  </p>
                  <p>
                      - Partial fulfilment of the trip package by the Local Designer or any unsatisfactory performance of any trip package, including any dissatisfaction on your part of any component of the trip package.
                  </p>
                  <p>
                      - Claims relating to unsatisfactory or partial performance should be brought directly to the Local Designer.
                  </p>
                  <p>
                      - Rescheduled or cancelled transportation, unavailability of specific accommodation, meal, or tour preferences, bona fide errors, lost or stolen personal items or funds you bring on your trip, or other events occurring during the trip.
                  </p>
                  <p>
                      - Any claims not covered by the above terms.
                  </p>
                  <p class='mb-0'>
                      - Any other issues not within the financial default of the Local Designer.
                  </p>
                  <img :src="`${$assetsCdn}/images/general/partner-atas-logo.svg`" class="w-200 mt-16 mb-16"/>
                  <div>
                    <strong class='fw-700'>
                      ATAS Accreditation
                    </strong>
                  </div>
                  <div class="mt-8">Designer Journeys is proudly accredited by ATAS or the AFTA Travel Accreditation Scheme is administered by the Australian Federation of Travel Agents, the peak industry body for Australian travel agents.</div>
                  <div class="mt-8">Accreditation number: A17182</div>
              </div>
          </template>
      </NuxtLayout>
  </div>
</template>

<script>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'

// import DefaultLayout from '../../components/globals/layout/DefaultLayout'
import Banner from '~/components/sections/SectionBannerTitle/BannerTitle'
// import { useHead } from '@vueuse/head'
import { onMounted/*,computed, ref*/ } from 'vue'
// import Metadata from '~/assets/meta_data.json'

export default {
  name: 'traveller-protections',
  components: {
    /*DefaultLayout,*/
    Banner
  },
  setup() {
    // const route = useRoute()
    // const runtime = useRuntimeConfig()
    // const metaData = ref(Metadata);
    // const canonical = runtime.public.publicDomain + route.path

    onMounted(() => {
      debounceAmplitudeScriptTracking("View Traveller Protections")
    })

    // useHead({
    //   title: computed(() => {
    //     const title = metaData.value.traveller_protections.title
    //     return title
    //   }),
    //
    //   meta: computed(() => {
    //     const title = metaData.value.traveller_protections.title
    //     const description = metaData.value.traveller_protections.description
    //     return [
    //       {
    //         name: `title`,
    //         content: title,
    //       },
    //       {
    //         name: `description`,
    //         content: description,
    //       }
    //     ]
    //   }),
    //   link: computed(() => {
    //     return [
    //       { rel: 'canonical', href: `${canonical}`}
    //     ]
    //   }),
    // })
  }
}
</script>

